export const PRECAMPAIGN_AMPLITUDE_PAGE_NAME = 'Pre Campaign';
export const PRECAMPAIGN_PAGE_KEY = 'precampaign';

export const CAMPAIGN_AMPLITUDE_PAGE_NAME = 'Campaign Landing';
export const CAMPAIGN_PAGE_KEY = 'campaign';

export const SEO = {
  og_data: {
    type: 'crehana:product',
    site_name: 'Crehana',
    image: {
      url: 'https://static.crehana.com/static/img/logo/logo-crehana.6a48047513e0.png',
      alt: 'Crehana',
    },
  },
};
